export enum AccentColor {
  teal = "teal",
  pumpkin = "pumpkin",
  violet = "violet",
  scarlet = "scarlet",
  patina = "patina",
  transparent = "transparent",
}
